@if (isReadonly()) {
  <div class="field-height mt-3">
    <div class="d-block mb-2">{{ title() }}</div>
    <div
      class="border rounded p-2 scrollable"
      [style.maxHeight.rem]="11"
      [style.whiteSpace]="'pre-wrap'">
      {{ textContent() }}
    </div>
  </div>
} @else {
  <form>
    <div class="field-height">
      <ap-field
        [title]="title()"
        [gstarTextareaOverflowButton]="false"
        [fieldTitle]="title()"
        [textContent]="textContent()"
        [htmlElement]="commentArea"
        class="field-height mt-3"
        [disabled]="false">
        <textarea
          appkit-field
          #commentArea
          [ngModel]="textContent()"
          (ngModelChange)="commentUpdate($event)"
          [ngModelOptions]="{ standalone: true }"
          [style.height.px]="commentArea.scrollHeight"
          [style.maxHeight.rem]="'11'">
        </textarea>
      </ap-field>
    </div>
  </form>
}
